import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import reducers from "../reducers";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const enhancer = compose(applyMiddleware(thunk));
const pReducer = persistReducer(persistConfig, combineReducers(reducers));

export const store = createStore(pReducer, enhancer);
export const persistor = persistStore(store);
